<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            src="/img/avatars/7.jpg"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>ااعلان ها</strong>
    </CDropdownHeader>

    <CDropdownItem>
      <CIcon name="cil-envelope-open" />پیام
      <CBadge color="success" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
<!--    <CDropdownItem>-->
<!--      <CIcon name="cil-task" /> فعالیت-->
<!--      <CBadge color="danger" class="ml-auto">{{ itemsCount }}</CBadge>-->
<!--    </CDropdownItem>-->
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong :text="name"></strong>
    </CDropdownHeader>
    <CDropdownItem :to="{path: '/user'}">
      <CIcon name="cil-user" /> پروفایل کاربری
    </CDropdownItem>
<!--    <CDropdownItem>-->
<!--      <CIcon name="cil-file" /> پروژه های من-->
<!--      <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge>-->
<!--    </CDropdownItem>-->
    <CDropdownDivider/>

    <CDropdownItem  @click="logout">
      <CIcon name="cil-lock-locked" /> خروج
    </CDropdownItem>
  </CDropdown>
</template>


<script>
    import axios from 'axios';

    export default {

        name: 'TheHeaderDropdownAccnt',

        data() {

            return {
                tokenSet: false,

              auth: {
                headers: {
                  Authorization: 'bearer ' + localStorage.getItem('token')
                }
              },

                userData: {
                    email: "",
                    password: ""
                },

                name: "",
                family: "",
                username: "",  // used as mobile
                email: "",
                state: "",
                itemsCount: 0,


              notifications:[],






            }
        },


        mounted() {


            if(localStorage.getItem('token'))
                this.tokenSet = true

            if(localStorage.getItem('name'))
                this.name = localStorage.getItem('name')

            if(localStorage.getItem('mobile'))
                this.username = localStorage.getItem('mobile')

            if(localStorage.getItem('email'))
                this.email = localStorage.getItem('email')

            if(localStorage.getItem('state'))
                this.state = localStorage.getItem('state')



          // this.notification()

        },



        methods: {


            logout() {
                localStorage.removeItem('token');
                localStorage.removeItem('id');
                localStorage.removeItem('name');
                localStorage.removeItem('family');
                localStorage.removeItem('email');
                localStorage.removeItem('state');
                localStorage.removeItem('role');
                localStorage.removeItem('roles');
                axios.get('/api/auth/logout', this.auth);
                this.$router.push({
                    path: '/login'
                });

            },


          notification() {
            var app = this;
            axios.get('/api/notifications', app.auth)
                    .then(response => {
                      app.notifications = response.data.data;
                      console.log(app.notifications,"notifactionList")
                      if (app.notifications.length)
                        app.itemsCount = app.notifications.length
                    })
                    .catch(error => {
                      console.log(error);
                      console.log(error.response.status);

                      if (error.response.status === 401)
                      app.logout()
                      // app.$snotify.warning(' خطا رخ داده است');
                    })
          },







        }
    }


</script>






<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>